import { render, staticRenderFns } from "./vistaPreviaCorreo.vue?vue&type=template&id=78509d34&"
import script from "./vistaPreviaCorreo.vue?vue&type=script&lang=js&"
export * from "./vistaPreviaCorreo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports